module.exports = {"jugar":"Play","instrucciones":"Instructions"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/home/en.json
// module id = 172
// module chunks = 13